import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { STATUSES, TYPES } from '~/utils'

export type GoogleListingHoverPopupListing = {
  address?: string
  isBusinessListing?: boolean
  lat: number
  lng: number
  name: string
  propertyTypes: string
  status: string
  thumbUrl?: string
  type: string
}

export type GoogleListingHoverPopupProps = {
  listing: GoogleListingHoverPopupListing
}

export function GoogleListingHoverPopupContent({
  listing,
}: GoogleListingHoverPopupProps) {
  return (
    <div className="w-[260px] max-w-[calc(100vw-3rem)] overflow-hidden rounded-md bg-background shadow-md">
      {listing.thumbUrl ? (
        <div className="relative aspect-video overflow-hidden rounded-t-md">
          <img
            alt=""
            className="absolute h-full w-full object-cover"
            src={listing.thumbUrl}
          />
        </div>
      ) : null}
      <div className="px-4 py-3">
        <p className="mb-1 line-clamp-1 text-sm font-medium">
          {listing.name}
        </p>
        {listing.address ? <p className="text-sm">{listing.address}</p> : null}
        <p className="text-sm">
          {STATUSES[listing.status]} - {TYPES[listing.type]} -{' '}
          {listing.propertyTypes}
        </p>
        {listing.isBusinessListing ? (
          <p className="text-sm">Business</p>
        ) : null}
      </div>
    </div>
  )
}

export function GoogleListingHoverPopup({
  listing,
}: GoogleListingHoverPopupProps) {
  return (
    <AdvancedMarker
      position={{ lat: listing.lat, lng: listing.lng }}
      anchorLeft="-50%"
      anchorTop="calc(-100% - 10px)"
      zIndex={50}>
      <div className="pointer-events-none">
        <GoogleListingHoverPopupContent listing={listing} />
      </div>
      <div className="absolute left-1/2 top-full h-4 w-4 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-background" />
    </AdvancedMarker>
  )
}
